


import { Section } from "./data-types";

export const TestGallery: {
	sections: (Section | (() => JSX.Element))[];
} = {
	sections: [
		{
			type: "grid-gallery",
			options: {
				columns: 2,
			},
			items: [
				"/images/gallery/Blackstairs_Mountain.png",
				"/images/gallery/Cut_Bog.jpg",
				"/images/gallery/Devils_Matchstick_Lichen.png",
				"/images/gallery/PXL_20240826_101236903.jpg",
				"/images/gallery/Avoca_BallymurtaghMine.png",
				"/images/gallery/PXL_20240826_115630027.jpg",
				"/images/gallery/Round-Level_Sundew.png",
				"/images/gallery/TinyFrog2.jpg"
			]
		}
	]
}
